import { FC, useEffect, useState } from 'react'
import { InView } from 'react-intersection-observer'

import { FigsLoader } from '@syconium/little-miss-figgy'

import { useConditionallyLoadMoreItems } from '../../../brunswick/components/pages/Collection/hooks/useConditionallyLoadMoreItems'

import { BulkContainer } from './containers/BulkContainer'
import { LoadingWrapper } from './styles'

export const BulkFetchMore: FC = () => {
  const [isInView, setIsInView] = useState(false)
  const [loadAgainCount, setLoadAgainCount] = useState(0)
  const { paginate, loading } = BulkContainer.useContainer()

  const { conditionallyLoadMoreItems, isLoadingMoreItems } = useConditionallyLoadMoreItems({
    loadMoreItems: paginate,
  })

  useEffect(() => {
    if (!isInView) return
    let effectStatus = {
      isCurrent: true,
    }

    if (isInView && !isLoadingMoreItems) {
      conditionallyLoadMoreItems().then(() => {
        if (effectStatus.isCurrent && isInView) {
          setLoadAgainCount(prev => prev + 1)
        }
      })
    }

    return () => {
      effectStatus.isCurrent = false
    }
  }, [conditionallyLoadMoreItems, isInView, isLoadingMoreItems, loadAgainCount])

  return (
    <div>
      {loading && (
        <LoadingWrapper>
          <FigsLoader />
        </LoadingWrapper>
      )}
      <InView
        rootMargin='0px 0px 750px 0px'
        onChange={isVisible => {
          setIsInView(isVisible)
        }}
      />
    </div>
  )
}
